import requestManager from './RequestManager';
import { useStore, useData } from '../store';
const { scan_token, mini_token, channel } = useStore();
const { init_data } = useData();
import { logNoUa } from './log';
import { MD5 } from 'crypto-js';
function getApiSignature(sign_message, secret_key) {
  const dataToHash = [sign_message, secret_key].join('');
  const sign = MD5(dataToHash).toString();
  return sign;
}

function getApiSignParams(h5_user_id, api, method, body) {
  const url = new URL(api);
  const full_path = url.pathname + url.search;
  const timestamp = Date.now();
  const nonce = ''
    .concat(Math.random().toString(36).slice(-8))
    .concat(timestamp)
    .concat(Math.random().toString(36).slice(-8));
  const sign_message = ''
    .concat(h5_user_id, '\n')
    .concat(method.toLocaleUpperCase(), '\n')
    .concat(full_path, '\n')
    .concat(timestamp, '\n')
    .concat(nonce, '\n')
    .concat(body ? JSON.stringify(body) : '');
  return [nonce, timestamp, sign_message];
}

function apiSign(h5_user_id, api, method, body) {
  const [nonce, timestamp, sign_message] = getApiSignParams(
    h5_user_id,
    api,
    method,
    body
  );
  console.log('sign_message', sign_message);
  const signature = getApiSignature(sign_message, secret_key);
  const headers = {
    'H5-User-Id': h5_user_id,
    'H5-Nonce': nonce,
    'H5-Timestamp': timestamp,
    'H5-Signature': signature,
  };
  return headers;
}

class Semaphore {
  constructor(maxConcurrency) {
    this.maxConcurrency = maxConcurrency;
    this.currentConcurrency = 0;
    this.queue = [];
  }

  acquire() {
    if (this.currentConcurrency < this.maxConcurrency) {
      this.currentConcurrency++;
      return Promise.resolve();
    } else {
      return new Promise((resolve) => {
        console.log(resolve, '添加');
        this.queue.push(resolve);
      });
    }
  }

  release() {
    if (this.queue.length > 0) {
      const next = this.queue.shift();
      console.log(next, '拿出来');
      next();
    } else {
      this.currentConcurrency--;
    }
  }
}
const semaphore = new Semaphore(5);
const headers = new Headers({
  'Content-Type': 'application/json',
  Accept: 'application/json',
  'Accept-Language': 'zh-CN,zh;q=0.9', // 设置返回中文
  'Cache-Control': 'no-cache', // 不使用缓存
  Pragma: 'no-cache',
});

// 天下手游获取角色列表
async function txm_get_roles() {
  return await get(`${import.meta.env.VITE_BASEAPI}/txm/jwt/get_roles`);
}

// 天下端游获取角色列表
async function tx3_get_roles() {
  return await get(`${import.meta.env.VITE_BASEAPI}/tx3/fcwgxt/get_roles`);
}

// 天下贰角色列表
async function tx2_get_roles() {
  return await get(`${import.meta.env.VITE_BASEAPI}/tx3/huiliu/get_roles`);
}

// 每次活动的一个init函数，一般会在登录之后进行调用
async function init() {
  return await get(`${import.meta.env.VITE_BASEAPI}/tx3/tx3_rssq_new_server/get_init_data`);
}

// 进行分享
async function get_do_share() {
  return await get(`${import.meta.env.VITE_BASEAPI}/tx3/tx3_rssq_new_server/do_share`);
}

async function get_server_list(project,tag){
  return await get(`${import.meta.env.VITE_BASEAPI}/v1/api/pay/orders/server_list?project=${project}&&h5_tag=${tag}`);
}

// 这里将会封装一个get请求，里面会做一些操作:
async function get(url, route, timeout = 10000) {
  await semaphore.acquire();
  return new Promise((resolve, reject) => {
    // 进行权限检查
    // if (!checkAuth()) {
    //     semaphore.release()
    //     resolve({
    //         status: '404',
    //         message: "没有权限访问"
    //     })
    //     return false
    // }

    const controler = new AbortController();
    const signal = controler.signal;
    requestManager.addRequest(url, signal);
    const timer = setTimeout(() => {
      requestManager.removeRequest(url);
      controler.abort();
      clearTimeout(timer);
      semaphore.release();
      logNoUa({
        message: '请求超时',
        url: url,
      });
      reject(new Error('Request time out '));
    }, timeout);
    // 请求进入拦截
    if (scan_token.value) {
      headers.set('tx-scan-token', scan_token.value);
    }

    if (mini_token.value) {
      headers.set('tx-mini-token', mini_token.value);
    }

    if (channel.utm_source == 'gw' && channel.extra == 'gw') {
      headers.set('Tx-Platform', channel.utm_source);
    }
    if (channel.extra && channel.extra !== 'gw') {
      headers.set('Tx-Platform', channel.extra);
    }
    if (channel.utm_source && channel.utm_source !== 'gw') {
      headers.set('Tx-Platform', channel.utm_source);
    }

    headers.set('Cache-Control', 'no-cache, no-store, must-revalidate');
    headers.set('Pragma', 'no-cache');
    headers.set('Expires', '0');

    fetch(url, { signal, headers, credentials: 'include', cache: 'no-store' })
      .then((res) => {
        clearTimeout(timer);
        requestManager.removeRequest(url);
        if (!res.ok) {
          // 做下响应拦截
          let error = handleNetWorkError(res.status);
          semaphore.release();
          reject(error);
        }

        return res.json();
      })
      .then((data) => {
        semaphore.release();
        resolve(data);
        // 请求从响应出来之后
      })
      .catch((error) => {
        semaphore.release();
        reject(error);
      });
  });
}

//todo:在这里进行重写
// 这里会封装post请求，里面会做一些操作
// 请求的地址，数据，route
async function post(url, data, is_md5 = false, timeout = 10000) {
  await semaphore.acquire();
  return new Promise((resolve, reject) => {
    const controler = new AbortController();
    const signal = controler.signal;
    requestManager.addRequest(url, signal);

    const timer = setTimeout(() => {
      requestManager.removeRequest(url);
      controler.abort();
      clearTimeout(timer);
      semaphore.release();
      reject(new Error('Request time out '));
    }, timeout);

    // if (mini_token.value) {
    //   headers.set('tx-mini-token', mini_token.value);
    // }

    if (is_md5 && window.figureCode && init_data) {
      const [nonce, timestamp, sign_message] = getApiSignParams(
        window.figureCode,
        url,
        'POST',
        data
      );
      const signature = getApiSignature(sign_message, init_data.id);
      headers.set('H5-User-Id', window.figureCode);
      headers.set('H5-Nonce', nonce);
      headers.set('H5-Timestamp', timestamp);
      headers.set('H5-Signature', signature);
    }

    fetch(url, {
      signal,
      headers,
      body: JSON.stringify(data),
      method: 'POST',
      credentials: 'include',
    })
      .then((res) => {
        clearTimeout(timer);
        requestManager.removeRequest(url);
        if (!res.ok) {
          // 做下响应拦截
          let error = handleNetWorkError(res.status);
          semaphore.release();
          reject(error);
        }

        return res.json();
      })
      .then((data) => {
        semaphore.release();
        resolve(data);
        // 请求从响应出来之后
      })
      .catch((error) => {
        semaphore.release();
        reject(error);
      });
  });
}

async function bind_role(data) {
  return await post(
    `${import.meta.env.VITE_BASEAPI}/tx3/fcwgxt/bind_game_role`,
    data
  );
}

async function commit_order(data) {
  return await post(
    `${import.meta.env.VITE_BASEAPI}/tx3/box_24_07/commit_order`,
    data,
  );
}

async function collect_log(data) {
  const params = {
    activity: import.meta.env.VITE_NAME,
    h5user_id: window.figureCode,
    details: { page_name: 'home' },
    account_id: init_data?.account_data?.username || '',
  };
  const data2 = { ...params, ...data };
  return await post(
    `${import.meta.env.VITE_BASEAPI}/tx3/us/collect_log`,
    data2
  );
}

function handleNetWorkError(errStatus) {
  let errorMessage = '未知错误';
  switch (errStatus) {
    case 400:
      errorMessage = '错误的请求';
      break;
    case 401:
      errorMessage = '未授权，请重新登录';
      break;
    case 403:
      errorMessage = '拒绝访问';
      break;
    case 404:
      errorMessage = '请求错误，未找到资源';
      break;
    case 405:
      errorMessage = '请求方法不允许';
      break;
    case 408:
      errorMessage = '请求超时';
      break;
    case 500:
      errorMessage = '服务端出错';
      break;
    case 501:
      errorMessage = '网络未实现';
      break;
    case 502:
      errorMessage = '网络错误';
      break;
    case 503:
      errorMessage = '服务不可用';
      break;
    case 504:
      errorMessage = '网络超时';
      break;
    case 505:
      errorMessage = 'http版本不支持该请求';
      break;
    default:
      errorMessage = `其他连接错误-${errStatus}`;
  }
  // 这里要记下日志
  return errorMessage;
}

export {
  txm_get_roles,
  tx3_get_roles,
  tx2_get_roles,
  bind_role,
  get_do_share,
  init,
  get,
  post,
  commit_order,
  collect_log,
  get_server_list,
};
